// 请假
export default [
  {
    path: '/opendoor/index',
    name: 'PageOpenDoorIndex',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorIndex'
      ),
    meta: {
      modular: 161,
      title: '进出校管理',
      info: '进出校管理——首页',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/device/list',
    name: 'PageOpenDoorDeviceList',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorDeviceList'
      ),
    meta: {
      modular: 161,
      title: '进出校设备管理',
      info: '进出校——进出校设备管理',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/device/add',
    name: 'PageOpenDoorDeviceAdd',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorDeviceAdd'
      ),
    meta: {
      modular: 161,
      title: '添加设备',
      info: '进出校——添加设备',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/device/manage',
    name: 'PageOpenDoorDeviceManage',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorDeviceManage'
      ),
    meta: {
      modular: 161,
      title: '进出校设备管理',
      info: '进出校——进出校设备管理更多',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/group',
    name: 'PageOpenDoorGroup',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorGroup'
      ),
    meta: {
      modular: 161,
      title: '进出校规则',
      info: '进出校——进出校规则',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/search',
    name: 'PageOpenDoorSearch',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorSearch'
      ),
    meta: {
      modular: 161,
      title: '进出校管理',
      info: '进出校——进出校搜索',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/group/save',
    name: 'PageOpenDoorGroupSave',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorGroupSave'
      ),
    meta: {
      modular: 161,
      title: '',
      info: '进出校——保存规则',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/group/member',
    name: 'PageOpenDoorGroupMember',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorGroupMember'
      ),
    meta: {
      modular: 161,
      title: '通行人员',
      info: '进出校——通行人员',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/group/device',
    name: 'PageOpenDoorGroupDevice',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorGroupDevice'
      ),
    meta: {
      modular: 161,
      title: '选择设备',
      info: '进出校——选择设备',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/group/device/result',
    name: 'PageOpenDoorGroupDeviceResult',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorGroupDeviceResult'
      ),
    meta: {
      modular: 161,
      title: '已选择的设备',
      info: '进出校——已选择的设备',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/group/plan',
    name: 'PageOpenDoorGroupPlan',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorGroupPlan'
      ),
    meta: {
      modular: 161,
      title: '日常通行计划',
      info: '进出校——日常通行计划',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/group/plan/time',
    name: 'PageOpenDoorGroupPlanTime',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorGroupPlanTime'
      ),
    meta: {
      modular: 161,
      title: '通行时段',
      info: '进出校——通行时段',
      keepAlive: true
    }
  },
  {
    path: '/opendoor/group/parent/notice',
    name: 'PageOpenDoorGroupParentNotice',
    component: () =>
      import(
        /* webpackChunkName: "opendoor" */ '../pages/opendoor/PageOpenDoorGroupParentNotice'
      ),
    meta: {
      modular: 161,
      title: '学生刷脸照片',
      info: '进出校——家长通知',
      immediate: true
    }
  }
]
